import { jsx } from 'react/jsx-runtime';
import 'react';
import styled from '@emotion/styled';

const CardContainer = styled.div `
    background: #fff;
    box-shadow: ${({ noBoxShadow }) => noBoxShadow
    ? "none"
    : "0px 2px 6px 0px rgba(0, 0, 0, 0.19), 0px 0px 2px 0px rgba(0, 0, 0, 0.19)"};
`;
const Card = ({ children, noBoxShadow }) => {
    return jsx(CardContainer, { noBoxShadow: noBoxShadow, children: children });
};

export { Card };
